export function resolveMountedBasename(appSlug?: string): string {
  if (typeof window === "undefined") {
    return "/";
  }

  if (!appSlug) {
    return "/";
  }

  const mountPath = `/apps/${appSlug}`;
  const pathname = window.location.pathname;

  if (pathname === mountPath || pathname.startsWith(`${mountPath}/`)) {
    return mountPath;
  }

  return "/";
}
